class InfiniteScroll {
  constructor(config, callback) {
    this.activate = config?.activate ?? true
    if (typeof config === 'object' && config !== null && !Array.isArray(config)) {
      this.el = config.el
    } else {
      this.el = config
    }
    this.el = typeof this.el === 'string' || this.el instanceof String ? document.querySelector(this.el) : this.el
    this.active = false
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry && entry.isIntersecting) {
            callback()
          }
        })
      },
      {
        rootMargin: '0px 0px 95% 0px',
        threshold: 0.1,
      }
    )
    if (this.activate) {
      this.start()
    }
  }

  start() {
    this.observer.observe(this.el)
    this.active = true
  }

  stop() {
    this.observer.unobserve(this.el)
    this.active = false
  }
}
export { InfiniteScroll }
